/**************************************************
 * Nombre:       Formulario_Calculadora
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {Star, EventAvailableOutlined,MoneyOutlined} from "@mui/icons-material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";

const Formulario_Calculadora = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'felx-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={12}>
                    <IngresoTexto Icono={Star} nombre={'Nombra tu meta'} dato={'nombre'} {...props}

                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={EventAvailableOutlined} nombre={'Num Meses para tu meta'}
                                   dato={'numMeses'} {...props}
                                   opciones={[6, 12, 18, 24, 32, 48]}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={MoneyOutlined} nombre={'Monto a alcanzar'} dato={'valor'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Calculadora